import { parsePhoneNumberFromString } from "libphonenumber-js";

export const formatPhoneNumberIntl = (input: string): string => {
  const phoneNumber = parsePhoneNumberFromString(input);

  if (!phoneNumber || !phoneNumber.isValid()) {
    return input; // Retourne tel quel si invalide
  }

  return phoneNumber.formatInternational(); // Exemple: +261 34 75 896 36
};

export const checkValidNumber = (input?: string | null) => {
  if (!input) return false;
  const phoneNumber = parsePhoneNumberFromString(checkPhone(input));
  return phoneNumber && phoneNumber.isValid();
};

export const checkPhone = (phone: string) => {
  if (phone) {
    const _phone = phone.replace(/[^0-9]/g, "").trim();
    return `+${_phone}`;
  }
  return phone;
};
